import api from "./api";

const serviceService = {
    list: async () => {
        const { data } = await api.get("/services");
        return data;
    },

    create: async (data) => {
        const { data: result } = await api.post("/services", data);
        return result;
    },

    update: async (id, data) => {
        const { data: result } = await api.put(`/services/${id}`, data);
        return result;
    },

    delete: async (id) => {
        const { data } = await api.delete(`/services/${id}`);
        return data;
    },
};

export default serviceService;
